<div class="wrapper">
	<!-- Preloader -->
	<!-- <div class="preloader flex-column justify-content-center align-items-center">
		<img src="assets/img/docs-ia-logo-mini.png" alt="DocsiaLogo" height="60" width="60">
	</div> -->
	<app-header [display_messages]='display_messages' [display_notifications]='display_notifications'
		[display_tasks]='display_tasks' [display_user]='display_user'
		[header_components]='header_components'>LOADING
		header...</app-header>
	
	<app-menu-aside [links]="mylinks" [display_menu_user]='display_menu_user' [display_menu_search]='display_menu_search'>LOADING menu...</app-menu-aside>

	<!-- Content Wrapper. Contains page content -->
	<div class="content-wrapper">
		<!-- Content Header (Page header) -->
		<toaster-container></toaster-container>
		<app-breadcrumb></app-breadcrumb>

		<!-- Main content-->
		<section class="content">
			<div [ngClass]="{'box': boxed_style, 'box-default': boxed_style}">
				<div [ngClass]="{'box-body': boxed_style}">

					<router-outlet></router-outlet>
				</div>
			</div>
		</section>
		<!-- /.content -->
	</div>
	<!-- /.content-wrapper -->
	
	<app-footer></app-footer>
</div>
<!-- ./wrapper -->